import React from 'react'
import { useFormState } from 'react-final-form'
import { gsColors } from '../../styles/Variables'
import { Button } from '../../styles/Components'
import { mq } from '../../helpers'
import styled from '@emotion/styled'

const ButtonWrapper = styled.div`
  align-self: center;
  width: 800px;

  ${mq('max', '768px')} {
    width: unset;
  }

  button {
    width: 50%;
  }
`

const SubmitBtn = ({ fieldRefs, submitting }) => {
  const formState = useFormState({
    subscription: { submitFailed: true, errors: true },
  })

  // only used to scroll to next error if invalid form state
  const handleClick = () => {
    if (!formState.submitFailed) {
      return
    }

    const firstErrorField = Object.keys(formState.errors)[0]
    const el = fieldRefs.current[firstErrorField]

    if (el?.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.focus?.()
    }
  }

  return (
    <ButtonWrapper>
      <Button
        disabled={submitting}
        onClick={handleClick}
        color={gsColors.cobalt}
        type="submit"
        fill
        large
      >
        { submitting ? 'Submitting...' : 'Submit' }
      </Button>
    </ButtonWrapper>
  )
}

export default SubmitBtn
